import React, {Component} from 'react'
import CashRegister from '../cashRegister/CashRegister'

class KeyLeftColumn extends Component {
  render() {
    return <div className="tile is-12 is-child box">
      <p>Состав комплекта:</p>
      <ul style={{listStyle: 'none', marginLeft: '0'}}>
        <CashRegister register={this.props.register} handleRegisterSelect={this.props.handleRegisterSelect}/>
        {window.screen.width <= 1000 ? <li><strong>Информация и цена кассы ниже</strong></li>: null}
      </ul>
      <ul>
        <li>Фискальный накопитель</li>
        <li>Код активации ККТ на услугу ОФД</li>
        <li>Регистрация ЛК у ОФД и заключение договора с ОФД</li>
        <li>Регистрация/перерегистрация онлайн кассы без посещения ФНС</li>
        <li>Техническая настройка рабочего места (для регистрации онлайн-касс в ФНС, для работы с ЛК ОФД)</li>
        <li>Программное обеспечение для учета и автоматизации, интегрированное с онлайн кассой (лицензия, установка, настройка, первый запуск)</li>
        <li>Регистрации и активация кода ККТ у ОФД (подключение кассы к услуге ОФД)</li>
        <li>Абонентское обслуживание на год при работе с ОФД (информационно-консультационное и техническое)</li>
        <li>Экспертиза документов КЭП для доступа на сайт ФНС и сайт ОФД</li>
        <li>Защищенный сертифицированный носитель USB-токен JaCarta LT</li>
      </ul>
    </div>
  }
}

export default KeyLeftColumn


// WEBPACK FOOTER //
// ./src/components/ofdCalc/leftColumn/KeyLeftColumn.js